// Check if is RTL
const isRTL = getComputedStyle(document.body).direction === "rtl";

// Carousel multiple
let items = document.querySelectorAll(".carousel-multi .carousel-item");

items.forEach((el, index) => {
	// Número de diapositivas por elemento de carrusel
	const minPerSlide = 3;
	let prevIndex = index - 1;
	let next = el.nextElementSibling;

	for (var i = 1; i < minPerSlide; i++) {
		if (isRTL) {
			if (prevIndex < 0) {
				// Envolver el carrusel usando el último hijo
				prevIndex = items.length - 1;
			}

			let cloneChild = items[prevIndex].querySelector(".locationcard").cloneNode(true);
			el.appendChild(cloneChild);
			prevIndex--;
		} else {
			if (!next) {
				// wrap carousel by using first child
				next = items[0];
			}
			let cloneChild = next.cloneNode(true);
			el.appendChild(cloneChild.children[0]);
			next = next.nextElementSibling;
		}
	}
});

/**
 *
 * GSAP
 */

gsap.registerPlugin(ScrollTrigger);

/**
 * NAVBAR
 */

// Hide on scroll
const showNavbar = gsap
	.from("#main-nav", {
		yPercent: -100,
		paused: true,
		duration: 0.3,
	})
	.progress(1);

ScrollTrigger.create({
	start: "top top",
	end: 99999,
	onUpdate: (self) => {
		self.direction === -1 ? showNavbar.play() : showNavbar.reverse();
	},
});

// Collapse menu
const navbarToggler = document.querySelector(".navbar-toggler"); // Button
const navbarCollapse = document.querySelector("#navbarNavDropdown"); // Collapsed menu
const navbarMenu = document.querySelector("#navbar-menu"); // White box with links
const htmlDir = document.documentElement.getAttribute("dir");

// Click in Toggler button
navbarToggler.addEventListener("click", function () {
	if (navbarToggler.classList.contains("collapsed")) {
		// Hide menu
		gsap.to(navbarCollapse, { autoAlpha: 0, duration: 0.5, ease: "power4.out" });
		gsap.to(navbarMenu, { x: htmlDir === "rtl" ? "-100%" : "100%", duration: 1.5, ease: "power4.out" });
		document.body.classList.remove("no-scroll"); // Allow scroll
	} else {
		// Show menu
		gsap.to(navbarCollapse, { autoAlpha: 1, duration: 0.5, ease: "power4.out" });
		gsap.to(navbarMenu, { x: "0%", duration: 1.5, ease: "power4.out" });
		document.body.classList.add("no-scroll"); // No scroll
	}
});

// Click in Collapse (when is open)
navbarCollapse.addEventListener("click", function (e) {
	if (this === e.target) {
		if (!navbarToggler.classList.contains("collapsed")) {
			// Hide menu
			gsap.to(navbarCollapse, { autoAlpha: 0, duration: 0.5, ease: "power4.out" });
			gsap.to(navbarMenu, { x: htmlDir === "rtl" ? "-100%" : "100%", duration: 1.5, ease: "power4.out" });
			document.body.classList.remove("no-scroll"); // Allow scroll
			navbarToggler.classList.add("collapsed");
		}
	}
});

// Special color in home-header
document.addEventListener("DOMContentLoaded", function () {
	if (document.querySelector(".home")) {
		var menu = document.querySelector("#main-nav");

		//adde the class on loading
		menu.classList.add("navbar--home");

		//Remove on scroll
		window.addEventListener("scroll", function () {
			if (window.scrollY > 200) {
				menu.classList.remove("navbar--home");
			} else {
				menu.classList.add("navbar--home");
			}
		});
	}
});

/**
 * HEADER ANIMATION
 */

if (document.querySelector(".header__title")) {
	gsap.from(".header__title", {
		y: 80,
		autoAlpha: 0,
		duration: 2,
		delay: 0.1,
		ease: "power4.out",
	});
	gsap.from(".header__subtitle", {
		y: 100,
		autoAlpha: 0,
		duration: 2,
		ease: "power4.out",
		delay: 0.2,
	});
	gsap.from(".header__buttons", {
		y: 120,
		autoAlpha: 0,
		duration: 2,
		ease: "power4.out",
		delay: 0.3,
	});
	gsap.from(".header__image-wrap", {
		autoAlpha: 0,
		duration: 2,
		delay: 0.3,
		ease: "power4.out",
	});
}

/**
 * FADE ANIMATION
 */

// Individual
const fadeIn = gsap.utils.toArray(".fadeIn");
fadeIn.forEach((element, i) => {
	const anim = gsap.from(element, { autoAlpha: 0, y: 150, duration: 2.5, ease: "power4.out" });

	ScrollTrigger.create({
		trigger: element,
		animation: anim,
		start: "top bottom",
	});
});

// Fade in Steps
let fadeInSteps = document.querySelectorAll(".fadeInSteps");

fadeInSteps.forEach((step) => {
	let tl = gsap.timeline().pause(); // Pause the timeline immediately after creating it

	tl.staggerFrom(
		step.children,
		1,
		{
			autoAlpha: 0,
			y: 100,
			duration: 5,
			ease: "power4.out",
		},
		0.1
	);

	ScrollTrigger.create({
		trigger: step,
		start: "30% bottom",
		onEnter: () => tl.play(), // Play the timeline when entering the trigger
		once: true, // The trigger will only occur once
	});

	if (ScrollTrigger.isPastScrollEnd) {
		// If we're already past the trigger point on page load, force the timeline to play
		tl.play();
	}
});

// Media
if (document.querySelector(".fadeImage")) {
	let fadeImage = document.querySelectorAll(".fadeImage");
	fadeImage.forEach((container) => {
		let media = container.querySelector("img, video");
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: container,
				start: "-100% bottom-=20%",
			},
		});

		tl.set(container, { autoAlpha: 1 });
		tl.from(container, 1.5, {
			yPercent: 100,
			ease: Power4.out,
		});
		tl.from(media, 1.5, {
			yPercent: -100,
			delay: -1.5,
			ease: Power4.out,
		});
	});
}

/**
 *
 *
 *
 * LOTTIE
 */

//Function

function loadLottieAnimation(elementId, fileName) {
	const basePath = "/wp-content/themes/understrap-child/animations/";
	let element = document.getElementById(elementId);
	if (element) {
		lottie.loadAnimation({
			container: element,
			path: basePath + fileName,
			renderer: "svg",
			loop: true,
			autoplay: true,
		});
	}
}

// Load animations
loadLottieAnimation("lottieHeaderB2B", "header/header-yoopass-b2b.json");
loadLottieAnimation("lottieHeaderParking", "header/header-yoopass-parking.json");
loadLottieAnimation("homeHeaderAnimation", "home-header.json");
loadLottieAnimation("lottieParking", "parking-feature.json");
loadLottieAnimation("lottieB2B", "b2b-feature.json");
